import axiosInstance from './api';
import { MENU_EXTRACT_FILE_FIELD } from '../components/Events/ManageEvent/eventFormConstants';

const getApiErrorMessage = (error, fallback) => {
  if (!error) return fallback;
  if (typeof error === 'string') return error;
  return error.message || error?.error?.message || error?.data?.message || fallback;
};

/**
 * POST /admin/extract-menu-items — multipart file upload; returns parsed menuItems by course.
 */
export const extractMenuItemsFromFile = async (file) => {
  if (!(file instanceof File)) {
    return { success: false, message: 'Please select a file to upload.' };
  }

  const formData = new FormData();
  formData.append(MENU_EXTRACT_FILE_FIELD, file);

  try {
    const response = await axiosInstance.post('/admin/extract-menu-items', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    const payload = response.data;
    const data = payload?.data ?? payload;
    const menuItems = data?.menuItems;

    if (!menuItems || typeof menuItems !== 'object') {
      return {
        success: false,
        message: payload?.message || 'No menu items returned from server.',
      };
    }

    return {
      success: true,
      menuItems,
      message: payload?.message || 'Menu items extracted successfully',
      sourceType: data?.sourceType,
    };
  } catch (error) {
    return {
      success: false,
      message: getApiErrorMessage(error, 'Failed to extract menu items'),
      error,
    };
  }
};
